import React, { forwardRef } from 'react';
import { FormHelperText as MuiFormHelperText } from '@mui/material';
import { isEmpty } from 'lodash';

import { reportErrorInProductionOrThrow } from '~/Utils';

/**
 * This Component is a wrapper on MUI component.
 * This component should be imported and not MUI directly!
 *
 * Explicit FormHelperText props based on actual usage in the codebase.
 */
export interface FormHelperTextProps {
  /** If `true`, the helper text is displayed in an error state. */
  error?: boolean;
  /** The content of the helper text (typically a validation message). */
  children?: React.ReactNode;
  /** CSS class name applied to the root element. */
  className?: string;
  /** Inline styles applied to the root element. */
  style?: React.CSSProperties;
}

const FormHelperText = forwardRef<HTMLParagraphElement, FormHelperTextProps>(
  ({ error, children, className, style, ...restProps }, ref) => {
    if (!isEmpty(restProps)) {
      reportErrorInProductionOrThrow(
        `Unexpected props passed to FormHelperText: ${Object.keys(restProps).join(', ')}.
Examine if these need to be removed, or added explicitly to the FormHelperTextProps interface and to the component's signature.`,
        true
      );
    }
    return (
      <MuiFormHelperText error={error} className={className} style={style} ref={ref} {...restProps}>
        {children}
      </MuiFormHelperText>
    );
  }
);

FormHelperText.displayName = 'FormHelperText';

export default FormHelperText;
